/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";

export default function ShippingInformation() {
  const [ShippingInfoList, setShippingInfoList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [error, setError] = useState(false);
  const [shipping_charge, setshipping_charge] = useState("");
  const [canvas_size, setcanvas_size] = useState("");
  const [delivery_day, setdelivery_day] = useState("");
  const [Min_delivery_day, setMin_delivery_day] = useState("");
  const [Max_delivery_day, setMax_delivery_day] = useState("");
  const [state, setstate] = useState("");
  const [selectedData, setSelectedData] = useState("");

  useEffect(() => {
    getShippingList();
  }, [search_key, currentPage]);

  useEffect(() => {
    const delivery = selectedData?.delivery_day;
    setshipping_charge(selectedData?.shipping_charge);
    setcanvas_size(selectedData?.canvas_size);
    setdelivery_day(selectedData?.delivery_day);
    setMin_delivery_day(delivery?.split(" ")[0]?.split("-")[0]);
    setMax_delivery_day(delivery?.split(" ")[0]?.split("-")[1]);
    console.log(
      Min_delivery_day,
      Max_delivery_day,
      delivery,
      delivery?.split(" ")[0]?.split("-")[1]
    );
  }, [selectedData]);

  const getShippingList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_SHIPPING_INFO, param).then((res) => {
      if (res?.data?.status === true) {
        setShippingInfoList(res?.data?.data?.rows);
        SetTotalPageCount(res?.data?.totalPages);
        SetTotalCount(res?.data?.totalItems);
        setCount(res?.data?.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };
  function Delete(id, name) {
    const data = {
      id: id,
    };

    showDeleteConfirmation(name, () => {
      PostService(API_URL.DELETE_SHIPPING_INFO, data).then(
        (res) => {
          if (res.data.status) {
            showSuccessAlert(res?.data?.message, getShippingList);
          } else {
            showErrorAlert(res.data?.message);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
        }
      );
    });
  }

  function resetFunc() {
    setcanvas_size("");
    setdelivery_day("");
    setshipping_charge("");
    setMin_delivery_day("");
    setMax_delivery_day("");
    setError(false);
    setsubmitLoader(false);
  }

  function updateInfo() {
    if (
      !shipping_charge ||
      !canvas_size ||
      !Min_delivery_day ||
      !Max_delivery_day
    ) {
      setError(true);
      return;
    }
    setsubmitLoader(true);
    const data = {
      shipping_charge,
      canvas_size,
      id: selectedData?.id,
      delivery_day: (Min_delivery_day && Max_delivery_day)? `${Min_delivery_day}-${Max_delivery_day} days`:'',
    };
    const route= state==='Add' ? API_URL.ADD_SHIPPING_INFO :API_URL.UPDATE_SHIPPING_INFO;
    PostService(route, data).then((res) => {
      setsubmitLoader(false);
      if (res?.data?.status) {
        document.getElementById("closeEditModal").click();
        showSuccessAlert(res?.data?.message, getShippingList);
      } else {
        showErrorAlert(res.data?.message);
      }
    });
  }

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Shipping Charge</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">
                  Shipping Charge
                </Link>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="card">
        <div className="card-body ">
          <div className="align-items-center d-flex justify-content-between row">
            <div className="col-md-4 p-0">
              <div className="offset-md-1">
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-target="#AddModal"
                  onClick={() => {
                    setstate("Add");
                    resetFunc();
                  }}
                >
                  Add Shipping
                </button>
              </div>
            </div>
            <div className="col-md-4 p-0">
              <nav className="navbar">
                <input
                  type="text"
                  name="firstnamesearch"
                  placeholder="Search by Keyword"
                  className="form-control"
                  autoComplete="off"
                  onChange={(e) => {
                    setTimeout(() => {
                      setsearch_key(e.target.value);
                      setCurrentPage(0);
                    }, 400);
                  }}
                />
              </nav>
            </div>
          </div>
          <div class="table-responsive mt-3">
            {!loading && (
              <table class="table table-hover table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Shipping Charge ($)</th>
                    <th>Canvas Size</th>
                    <th>Delivery Day</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {ShippingInfoList?.map((item, i) => (
                    <tr>
                      <td>{item?.shipping_charge}</td>
                      <td>{item?.canvas_size}</td>
                      <td>
                        {item?.delivery_day}
                        <i class="ti-arrow-down"></i>
                      </td>
                      <td>
                        <span
                          title="Edit"
                          style={{ cursor: "pointer" }}
                          className="mx-2"
                          data-toggle="modal"
                          data-target="#AddModal"
                          onClick={() => {
                            setSelectedData(item);
                            setstate("Edit");
                          }}
                        >
                          <i className="text-dark fas fa-pen"></i>
                        </span>
                        <span
                          title="Delete"
                          style={{ cursor: "pointer" }}
                          className="mx-2"
                          data-toggle="modal"
                          data-target="#DeleteModal"
                          onClick={() => {
                            Delete(item?.id, "Shipping Information");
                          }}
                        >
                          <i className="text-danger fas fa-trash"></i>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
                {ShippingInfoList && ShippingInfoList?.length === 0 && (
                    <tr>
                      <td colSpan="4" className="text-center">
                        <h6 className="p-3"> No Data Found </h6>
                      </td>
                    </tr>
                  )}
              </table>
            )}
            {loading ? (
              <div className="LoaderSpinner">
                  <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                <div>Loading... Please wait.</div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="AddModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                {state} Shipping
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="form-group">
                  <label>Shipping Charge</label>
                  <input
                    type="text"
                    name="ShippingCharge"
                    className="form-control"
                    placeholder="Shipping Charge"
                    value={shipping_charge}
                    onChange={(e) => {
                      setshipping_charge(e?.target?.value);
                    }}
                  />
                   {error && !shipping_charge && (
                        <div className="error mt-1">
                         shipping charge is required
                        </div>
                      )}
                </div>
                <div className="form-group">
                  <label>Canvas Size</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Canvas Size"
                    value={canvas_size}
                    onChange={(e) => {
                      setcanvas_size(e?.target?.value);
                    }}
                  />
                  {error && !canvas_size && (
                        <div className="error mt-1">
                          canvas size is required
                        </div>
                      )}
                </div>
                <div className="form-group">
                  <label>Delivery Days</label>
                  <div className="row">
                    <div className="col-5">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Min. Day"
                        value={Min_delivery_day}
                        onChange={(e) => {
                          setMin_delivery_day(e?.target?.value);
                        }}
                      />
                       {error && !Min_delivery_day && (
                        <div className="error mt-1">
                          Min Days is required
                        </div>
                      )}
                    </div>
                    <div className="col-5">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Max. Day"
                        value={Max_delivery_day}
                        onChange={(e) => {
                          setMax_delivery_day(e?.target?.value);
                        }}
                      />
                       {error && !Max_delivery_day && (
                        <div className="error mt-1">
                          Max Days is required
                        </div>
                      )}
                    </div>
                    <span className="text-small">Days</span>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  id="closeEditModal"
                  data-dismiss="modal"
                  // onClick={resetFunc}
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={()=>{updateInfo()}} >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i> // Replace with the appropriate Font Awesome spinner class
                  ) : state === "Add" ? (
                    "Add"
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
